import { autobind } from 'core-decorators'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import gifShape from 'shared/prop-types/gif'
import { trackPageView } from 'shared/util/analytics'
import { Actions, trackEvent } from 'shared/util/gif-detail-ga-events'
import Gif from './gif'
import { withGifDetailContextManager } from './gif-detail-context'
import InfoOverlay from './info'
import Overlays from './overlays'
// import RelatedGrid from './related/related'
// import { relatedClips } from 'shared/api'
// import ClipsCarousel from 'shared/components/clips-carousel'
// import styled from 'styled-components'
// import { SectionHeader } from 'shared/components/text-elements'
// import { getPingbackId } from '@giphy/js-util'
import { OffscreenContext } from '../router'

const { bool, func } = PropTypes

// const Header = styled(SectionHeader)`
//     display: flex;
//     justify-content: flex-start;
//     margin-top: 17px;
//     padding: 0px 0px 4px 8px;
// `

@withGifDetailContextManager
/**
 * The GifDetail component, rendering a single gif, its share
 * buttons, tags, and related gifs.
 * When loaded it creates sibling GifDetails, but that should be
 * managed by a parent component using state.
 */
class GifDetail extends PureComponent {
    static propTypes = {
        isOffScreen: bool.isRequired,
        toggleFavorite: func.isRequired,
        gif: gifShape.isRequired,
        nextGif: gifShape,
        previousGif: gifShape,
        isFavorite: bool.isRequired,
        setIsMetaVisible: func.isRequired,
        onGifChange: func.isRequired,
    }
    shouldAnimateFavorites = false
    // used only to prevent gif tap event while swiping
    isSwiping = false
    state = {
        activeGif: null,
        relatedClips: [],
    }
    async componentWillMount() {
        const {
            gif: { user, id, tags = [] },
            setIsMetaVisible,
        } = this.props
        setIsMetaVisible({ id, isVisible: !user || tags.indexOf('ad') > -1 })
        // const result = await relatedClips(id, getPingbackId())
        // this.setState({ relatedClips: result.data })
    }
    componentWillUnmount() {
        clearInterval(this.doneCopyingTimout)
    }
    componentDidMount() {
        const { isOffScreen } = this.props

        if (!isOffScreen) {
            window.scrollTo(0, 0)
        }
    }
    componentDidUpdate(prevProps) {
        const { gif, isOffScreen, isFavorite } = this.props

        if (gif.id !== prevProps.gif.id || (prevProps.isOffScreen !== isOffScreen && !isOffScreen)) {
            window.scrollTo(0, 0)
        }

        if (isFavorite !== prevProps.isFavorite) {
            this.shouldAnimateFavorites = false
        }
    }
    @autobind
    onDoubleTap() {
        this.shouldAnimateFavorites = true
        const {
            gif: { id },
            toggleFavorite,
        } = this.props
        toggleFavorite(id)
    }
    @autobind
    onSwipe(gif, isPrevious) {
        const {
            onGifChange,
            gif: { id },
        } = this.props
        trackEvent(isPrevious ? Actions.previousClick : Actions.nextClick, id)
        onGifChange(gif)
    }
    @autobind
    onRelatedFeedUpdate(gif) {
        const { slug, is_sticker: isSticker } = gif
        const { activeGif } = this.state
        this.setState({ activeGif: gif })
        if (activeGif && activeGif.id !== gif.id) {
            trackPageView(`/${isSticker ? 'stickers' : 'gifs'}/${slug}`)
        }
    }
    render() {
        const {
            gif,
            isPrivate,
            // isOffScreen,
            nextGif,
            previousGif,
        } = this.props
        const {
            activeGif,
            // relatedClips
        } = this.state
        const { slug, url } = gif
        const shareRendition = 'original'
        return (
            <div>
                <Gif
                    gif={gif}
                    nextGif={nextGif}
                    previousGif={previousGif}
                    isPrivate={isPrivate}
                    onSwipe={this.onSwipe}
                    onDoubleTap={this.onDoubleTap}
                    isSingle={true}
                >
                    <InfoOverlay gif={gif} rendition={shareRendition} isShareLauncher />
                </Gif>
                {/* {!!relatedClips.length && (
                    <>
                        <Header>Related Clips</Header>
                        <ClipsCarousel clips={relatedClips} title={'Related Clips'} maxItems={3} />
                    </>
                )} */}
                {/* {!isOffScreen && <RelatedGrid gif={gif} isPrivate={isPrivate} />} */}
                <Overlays
                    gif={activeGif || gif}
                    slug={activeGif ? activeGif.slug : slug}
                    url={activeGif ? activeGif.url : url}
                    rendition={shareRendition}
                />
            </div>
        )
    }
}

export default (props) => (
    <OffscreenContext.Consumer>
        {(isOffScreen) => {
            return <GifDetail isOffScreen={isOffScreen} {...props} />
        }}
    </OffscreenContext.Consumer>
)
